import { useGame } from "./store";

const ERROR_TOAST_MS = 14_000;

/** Budget-/Bau-Fehler: 14 s sichtbar (API liefert in Dev detaillierte budgetInsufficientMessage). */
export function pushBuildErrorToast(title: string, message: string) {
  useGame.getState().pushToast({
    tone: "error",
    title,
    message,
    durationMs: ERROR_TOAST_MS,
  });
}

export const BUILD_ERROR_TOAST_MS = ERROR_TOAST_MS;
